import React from 'react';
import { Link } from 'gatsby';
import * as styles from './header.module.scss';
import classnames from 'classnames';

import wolfireLogoSrc from './wolfire-games-logo.png';
import wolfireLogoSmSrc from './wolfire-games-logo-sm.png';
import Container from '../container/container';
import Social from '../social/social';
import Menu from '../menu/menu';

const Header = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = React.useState(false);

  return (
    <header className={styles.root}>
      <Container className={styles.container}>
        <Link className={styles.logo} to="/">
          <img src={wolfireLogoSrc} alt="Wolfire Games logo" height="52" width="178" />
        </Link>
        <nav
          className={classnames(styles.nav, {
            [styles.isOpen]: isMobileNavOpen,
          })}
        >
          <ul className={styles.links}>
            <li>
              <Link to="/" activeClassName={styles.isActive} className={styles.isHome}>
                <span>Home</span>
                <img src={wolfireLogoSmSrc} alt="Home" height="30" />
              </Link>
            </li>
            <li>
              <Link activeClassName={styles.isActive} partiallyActive to="/games">
                Games
              </Link>
            </li>
            <li>
              <Link activeClassName={styles.isActive} partiallyActive to="/blog">
                Blog
              </Link>
            </li>
            <li>
              <Link activeClassName={styles.isActive} to="/contact">
                Contact
              </Link>
            </li>
          </ul>
          <Social className={styles.social} />
        </nav>
        <Menu isOpen={isMobileNavOpen} onClick={() => setIsMobileNavOpen(!isMobileNavOpen)} />
      </Container>
    </header>
  );
};

export default Header;
